import { Controller } from '@hotwired/stimulus';
import { replaceWithCKEditor } from 'manage/ckeditor';

export default class extends Controller {
  connect() {
    this.editor = replaceWithCKEditor(this.element);
  }

  disconnect() {
    this.editor?.destroy();
  }
}
